import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Inicio',
      meta: { public: false },
      component: () => import('@/components/Inicio')
    },
    {
      path: '/',
      name: 'Home',
      meta: { public: false },
      component: () => import('@/components/Inicio')
    },
    {
      path: '/diplomado',
      name: 'Diplomado',
      meta: { public: false },
      component: () => import('@/components/RegDiplomado')
    }
  ]
})

export default router